import { render, staticRenderFns } from "./ModalMontosComisiones.vue?vue&type=template&id=3e56efda"
import script from "./ModalMontosComisiones.vue?vue&type=script&lang=js"
export * from "./ModalMontosComisiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports